<div class="d-flex align-items-center justify-content-md-start justify-content-center">
    <button class="btn btn-cancel btn-sec sm icon-start me-3 ms-md-auto align-items-center" [disabled]="1 == pageIndex"
        (click)="pageReturn('previous')">
        <span class="material-symbols-outlined">
            arrow_left_alt
        </span>
    </button>
    <span class="page">
        หน้า {{pageIndex}} จาก {{pageTotal}}
    </span>
    <button class="btn btn-primary sm icon-end ms-3 align-items-center" [disabled]="pageTotal == pageIndex"
        (click)="pageReturn('next')">
        <span class="material-symbols-outlined">
            arrow_right_alt
        </span>
    </button>
</div>